import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "notification",
  "use": "notification-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"notification\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path stroke=\"#000\" stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\" />\n    <text fill=\"#000\" font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\n      <tspan x=\"7.332\" y=\"12\">!</tspan>\n    </text>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol